import { render, staticRenderFns } from "./v-popups.vue?vue&type=template&id=0f579e96"
import script from "./v-popups.vue?vue&type=script&lang=js"
export * from "./v-popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f579e96')) {
      api.createRecord('0f579e96', component.options)
    } else {
      api.reload('0f579e96', component.options)
    }
    module.hot.accept("./v-popups.vue?vue&type=template&id=0f579e96", function () {
      api.rerender('0f579e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/popups/v-popups.vue"
export default component.exports